import RESTSerializer from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
export default class MenuHour extends RESTSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }
  modelNameFromPayloadKey() {
    return 'menu-sync/menu-hour';
  }
  serializeIntoHash(hash, type, record, options) {
    super.serializeIntoHash(hash, type, record, options);

    // eslint-disable-next-line no-param-reassign
    hash.menuHour = hash['menuSync/menuHour'];

    // eslint-disable-next-line no-param-reassign
    delete hash['menuSync/menuHour'];
  }
}